import React from "react";

import { Box, Button, Card, IconButton, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { useStyles } from "@remar/shared/dist/styles";

export const DeleteModalContent = ({
	onDelete,
	onClose,
	lessonType,
	title = "Delete Lesson",
	message = "Are you sure you want to delete this lesson ?",
	deleteAllMessage = "Yes, delete it all"
}: {
	onDelete: (_withDeleted: boolean) => void;
	onClose: () => void;
	lessonType?: string;
	title?: string;
	message?: string;
	deleteAllMessage?: string;
}) => {
	const classes = useStyles();
	return (
		<Box width={550}>
			<Card className={classes.card}>
				<Box display="flex" alignItems="flex-start" justifyContent="space-between" mb="40px">
					<Typography className={classes.title}>{title}</Typography>
					<IconButton className={classes.closeIcon} onClick={onClose}>
						<CloseIcon color="disabled" />
					</IconButton>
				</Box>
				<Box>
					<Typography className={classes.subTitle}>{message}</Typography>
				</Box>

				<Box display="flex" justifyContent="flex-end" alignItems="center" className={classes.modalFooter}>
					<Button className={classes.cancelBtn} size="medium" onClick={onClose}>
						No,Cancel
					</Button>
					{lessonType !== "Test Only" ? (
						<>
							<Button className={classes.deleteAllBtn} size="medium" onClick={() => onDelete(true)}>
								{deleteAllMessage}
							</Button>
							<Button className={classes.deleteLessonOnlyBtn} size="medium" onClick={() => onDelete(false)}>
								Yes, but keep the video
							</Button>
						</>
					) : (
						<Button className={classes.deleteBtn} size="medium" onClick={() => onDelete(false)}>
							Yes, Delete
						</Button>
					)}
				</Box>
			</Card>
		</Box>
	);
};
